import {ClienteActionTypes, SAVE_CLIENTE} from "../types/clienteActionTypes";
import {ICliente} from "../../entities/catalogos/ICliente";

export function saveCliente(cliente: ICliente): ClienteActionTypes {
    return{
        type: SAVE_CLIENTE,
        cliente
    }
}
